import { FC } from "react";

interface SVGreset {
  name?: string;
  className?: string;
  width?: any;
  height?: any;
  fill?: string | undefined;
  viewBox?: any;
  style?: any;
  fillOpacity?: any;
}

const SVGIcon: FC<SVGreset> = (props) => {
  const { name, ...reset } = props;
  const svgMap: { [key: string]: JSX.Element } = {
    // buyTicket
    AddIconSvg: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" />
      </svg>
    ),
    AccountSvg: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M6.00008 1.93335C6.77341 1.93335 7.40008 2.56002 7.40008 3.33335C7.40008 4.10669 6.77341 4.73335 6.00008 4.73335C5.22675 4.73335 4.60008 4.10669 4.60008 3.33335C4.60008 2.56002 5.22675 1.93335 6.00008 1.93335ZM6.00008 7.93335C7.98008 7.93335 10.0667 8.90669 10.0667 9.33335V10.0667H1.93341V9.33335C1.93341 8.90669 4.02008 7.93335 6.00008 7.93335ZM6.00008 0.666687C4.52675 0.666687 3.33341 1.86002 3.33341 3.33335C3.33341 4.80669 4.52675 6.00002 6.00008 6.00002C7.47341 6.00002 8.66675 4.80669 8.66675 3.33335C8.66675 1.86002 7.47341 0.666687 6.00008 0.666687ZM6.00008 6.66669C4.22008 6.66669 0.666748 7.56002 0.666748 9.33335V11.3334H11.3334V9.33335C11.3334 7.56002 7.78008 6.66669 6.00008 6.66669Z" />
      </svg>
    ),
    BackSvg: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.705 1.41L6.295 0L0.294998 6L6.295 12L7.705 10.59L3.125 6L7.705 1.41Z"
          fill="white"
        />
      </svg>
    ),
    RightArrowSvg: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z"
          fill="#A6A9B8"
        />
      </svg>
    ),
    Diamond: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.30825 0.666626H8.2623C8.32821 0.666614 8.39319 0.686312 8.45192 0.72411C8.51065 0.761907 8.56147 0.81673 8.60023 0.884099L10.1971 3.65847C10.2255 3.70783 10.2395 3.7681 10.2367 3.82902C10.2339 3.88994 10.2144 3.94775 10.1817 3.99259L5.43857 10.4857C5.41902 10.5124 5.39531 10.5337 5.36893 10.5482C5.34254 10.5628 5.31406 10.5703 5.28527 10.5703C5.25648 10.5703 5.228 10.5628 5.20162 10.5482C5.17524 10.5337 5.15153 10.5124 5.13197 10.4857L0.388863 3.99312C0.356011 3.94824 0.33651 3.89033 0.333691 3.82929C0.330872 3.76826 0.34491 3.70788 0.373408 3.65847L1.97032 0.884099C2.00907 0.81673 2.05989 0.761907 2.11863 0.72411C2.17736 0.686312 2.24234 0.666614 2.30825 0.666626Z"
          fill="#42E0A7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.14844 9.68824L8.76456 11.9004C8.78412 11.9271 8.80783 11.9485 8.83421 11.963C8.86059 11.9776 8.88907 11.9851 8.91786 11.9851C8.94665 11.9851 8.97513 11.9776 9.00151 11.963C9.0279 11.9485 9.05161 11.9271 9.07116 11.9004L13.8143 5.40739C13.847 5.36254 13.8665 5.30474 13.8693 5.24382C13.8721 5.1829 13.8581 5.12263 13.8297 5.07326L12.2328 2.29889C12.1941 2.23153 12.1432 2.1767 12.0845 2.1389C12.0258 2.10111 11.9608 2.08141 11.8949 2.08142H10.4168L11.3245 3.65845C11.3529 3.70781 11.3669 3.76808 11.3641 3.829C11.3612 3.88992 11.3418 3.94772 11.3091 3.99257L7.14844 9.68824Z"
          fill="#42E0A7"
        />
      </svg>
    ),
    CloseSvg: (
      <svg {...reset} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
          fill="white"
        />
      </svg>
    ),
    SuccessSvg: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M32 64C23.4525 64 15.4166 60.6714 9.37263 54.6275C3.3285 48.5834 0 40.5475 0 32C0 23.4525 3.3285 15.4166 9.37263 9.3725C15.4166 3.32863 23.4525 0 32 0C40.5475 0 48.5834 3.32863 54.6274 9.3725C60.6715 15.4166 64 23.4525 64 32C64 40.5475 60.6715 48.5834 54.6274 54.6275C48.5834 60.6714 40.5475 64 32 64ZM32 2.75C15.8715 2.75 2.75 15.8715 2.75 32C2.75 48.1285 15.8715 61.25 32 61.25C48.1285 61.25 61.25 48.1285 61.25 32C61.25 15.8715 48.1285 2.75 32 2.75Z"
          fill="#CCCCCC"
        />
        <path
          d="M27.4067 41.3993C27.0564 41.3993 26.7062 41.2664 26.438 41.0003L16.5047 31.1409C15.9657 30.6059 15.9624 29.7353 16.4974 29.1963C17.0323 28.6574 17.9028 28.654 18.4419 29.1889L27.403 38.0833L44.3705 21.1158C44.9075 20.5789 45.7782 20.5789 46.3152 21.1158C46.852 21.6528 46.852 22.5234 46.3152 23.0604L28.379 40.9967C28.1105 41.265 27.7587 41.3993 27.4067 41.3993Z"
          fill="#9C94FF"
        />
      </svg>
    ),
    // footer
    FooterTopBorderSvg: (
      <svg {...reset} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 0H32C32 1.65685 30.6569 3 29 3H3C1.34315 3 0 1.65685 0 0Z"
          fill="#9C94FF"
        />
      </svg>
    ),
    FooterUpComingSvg: (
      <svg {...reset} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20 6V2C20 0.9 19.1 0 18 0H2C0.9 0 0.00999999 0.9 0.00999999 2V6C1.11 6 2 6.9 2 8C2 9.1 1.11 10 0 10V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V10C18.9 10 18 9.1 18 8C18 6.9 18.9 6 20 6ZM18 4.54C16.81 5.23 16 6.53 16 8C16 9.47 16.81 10.77 18 11.46V14H2V11.46C3.19 10.77 4 9.47 4 8C4 6.52 3.2 5.23 2.01 4.54L2 2H18V4.54ZM7.07 12L10 10.12L12.93 12L12.04 8.64L14.73 6.44L11.26 6.23L10 3L8.73 6.22L5.26 6.43L7.95 8.63L7.07 12Z"
          fill="white"
        />
      </svg>
    ),
    FooterFriendsSvg: (
      <svg {...reset} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 8.75C4.66 8.75 0 9.92 0 12.25V14H14V12.25C14 9.92 9.34 8.75 7 8.75ZM2.34 12C3.18 11.42 5.21 10.75 7 10.75C8.79 10.75 10.82 11.42 11.66 12H2.34ZM7 7C8.93 7 10.5 5.43 10.5 3.5C10.5 1.57 8.93 0 7 0C5.07 0 3.5 1.57 3.5 3.5C3.5 5.43 5.07 7 7 7ZM7 2C7.83 2 8.5 2.67 8.5 3.5C8.5 4.33 7.83 5 7 5C6.17 5 5.5 4.33 5.5 3.5C5.5 2.67 6.17 2 7 2ZM14.04 8.81C15.2 9.65 16 10.77 16 12.25V14H20V12.25C20 10.23 16.5 9.08 14.04 8.81ZM13 7C14.93 7 16.5 5.43 16.5 3.5C16.5 1.57 14.93 0 13 0C12.46 0 11.96 0.13 11.5 0.35C12.13 1.24 12.5 2.33 12.5 3.5C12.5 4.67 12.13 5.76 11.5 6.65C11.96 6.87 12.46 7 13 7Z"
          fill="white"
          fillOpacity="0.6"
        />
      </svg>
    ),

    FooterBillionSvg: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M25.3333 6.66667H22.6667V4H9.33333V6.66667H6.66667C5.2 6.66667 4 7.86667 4 9.33333V10.6667C4 14.0667 6.56 16.84 9.85333 17.2533C10.6933 19.2533 12.4933 20.76 14.6667 21.2V25.3333H9.33333V28H22.6667V25.3333H17.3333V21.2C19.5067 20.76 21.3067 19.2533 22.1467 17.2533C25.44 16.84 28 14.0667 28 10.6667V9.33333C28 7.86667 26.8 6.66667 25.3333 6.66667ZM6.66667 10.6667V9.33333H9.33333V14.4267C7.78667 13.8667 6.66667 12.4 6.66667 10.6667ZM16 18.6667C13.8 18.6667 12 16.8667 12 14.6667V6.66667H20V14.6667C20 16.8667 18.2 18.6667 16 18.6667ZM25.3333 10.6667C25.3333 12.4 24.2133 13.8667 22.6667 14.4267V9.33333H25.3333V10.6667Z" />
      </svg>
    ),
    FooterChatroomSvg: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 0H2C0.9 0 0 0.9 0 2V20L4 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 14H4L2 16V2H18V14Z"
          fill="white"
          fillOpacity="0.6"
        />
      </svg>
    ),
    FooterAccountSvg: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M9.99984 0C4.70984 0 0.416504 4.48 0.416504 10C0.416504 15.52 4.70984 20 9.99984 20C15.2898 20 19.5832 15.52 19.5832 10C19.5832 4.48 15.2898 0 9.99984 0ZM5.27525 16.28C5.68734 15.38 8.19817 14.5 9.99984 14.5C11.8015 14.5 14.3219 15.38 14.7244 16.28C13.4211 17.36 11.7823 18 9.99984 18C8.21734 18 6.57859 17.36 5.27525 16.28ZM16.0948 14.83C14.7244 13.09 11.399 12.5 9.99984 12.5C8.60067 12.5 5.27525 13.09 3.90484 14.83C2.92734 13.49 2.33317 11.82 2.33317 10C2.33317 5.59 5.77359 2 9.99984 2C14.2261 2 17.6665 5.59 17.6665 10C17.6665 11.82 17.0723 13.49 16.0948 14.83ZM9.99984 4C8.14067 4 6.64567 5.56 6.64567 7.5C6.64567 9.44 8.14067 11 9.99984 11C11.859 11 13.354 9.44 13.354 7.5C13.354 5.56 11.859 4 9.99984 4ZM9.99984 9C9.20442 9 8.56234 8.33 8.56234 7.5C8.56234 6.67 9.20442 6 9.99984 6C10.7953 6 11.4373 6.67 11.4373 7.5C11.4373 8.33 10.7953 9 9.99984 9Z" />
      </svg>
    ),
    // topData
    TopDataLogo: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_865_9862)">
          <path
            d="M22.4667 0.84021L13.8879 5.79381V5.80461L9.59668 8.28141L13.8879 10.7582L22.4667 5.80461V23.4374H27.0963V0.84021H22.4667Z"
            fill="#9C94FF"
          />
          <path
            d="M18.0641 13.314L13.8881 15.7224L9.71209 13.314V18.2748H5.30929V5.79363L9.59689 3.31683L5.30929 0.840027H0.679688V23.4372H5.30929H9.71209V18.2784L13.8881 20.6868L18.0641 18.2784V13.314Z"
            fill="#9C94FF"
          />
        </g>
        <defs>
          <clipPath id="clip0_865_9862">
            <rect
              width="26.4168"
              height="22.5972"
              fill="white"
              transform="translate(0.679688 0.840027)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    TopDataDiamond: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.48118 3.82878e-09H5.94672C5.99616 -8.6831e-06 6.04489 0.0147647 6.08894 0.0431127C6.13299 0.0714606 6.1711 0.112578 6.20017 0.163105L7.39785 2.24388C7.41914 2.2809 7.42962 2.32611 7.42751 2.3718C7.4254 2.41749 7.41082 2.46084 7.38626 2.49448L3.82893 7.36427C3.81426 7.3843 3.79648 7.40028 3.77669 7.41121C3.75691 7.42214 3.73555 7.42778 3.71395 7.42778C3.69236 7.42778 3.671 7.42214 3.65121 7.41121C3.63143 7.40028 3.61364 7.3843 3.59898 7.36427L0.0416456 2.49487C0.0170062 2.46121 0.00238034 2.41778 0.000266203 2.372C-0.00184793 2.32622 0.00868085 2.28094 0.0300541 2.24388L1.22774 0.163105C1.2568 0.112578 1.29492 0.0714606 1.33897 0.0431127C1.38302 0.0147647 1.43175 -8.6831e-06 1.48118 3.82878e-09Z"
          fill="#42E0A7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.11133 6.76621L6.32342 8.42536C6.33809 8.44539 6.35587 8.46137 6.37566 8.4723C6.39544 8.48323 6.4168 8.48887 6.4384 8.48887C6.45999 8.48887 6.48135 8.48323 6.50114 8.4723C6.52092 8.46137 6.53871 8.44539 6.55337 8.42536L10.1107 3.55557C10.1353 3.52194 10.1498 3.47858 10.152 3.43289C10.1541 3.3872 10.1436 3.342 10.1223 3.30498L8.92461 1.2242C8.89555 1.17367 8.85743 1.13256 8.81338 1.10421C8.76933 1.07586 8.7206 1.06109 8.67117 1.0611H7.56259L8.24339 2.24387C8.26468 2.28089 8.27516 2.32609 8.27305 2.37178C8.27093 2.41747 8.25636 2.46082 8.2318 2.49446L5.11133 6.76621Z"
          fill="#42E0A7"
        />
      </svg>
    ),
    TopDataDollar: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.81402 9.125C1.22459 9.025 0.772358 8.79583 0.457317 8.4375C0.152439 8.07917 0 7.62083 0 7.0625V6.4875H1.58537V7.15C1.58537 7.65833 1.875 7.9125 2.45427 7.9125C3.03354 7.9125 3.32317 7.65 3.32317 7.125C3.32317 6.8 3.22154 6.50833 3.01829 6.25C2.81504 5.98333 2.43902 5.675 1.89024 5.325C1.20935 4.88333 0.731707 4.47083 0.457317 4.0875C0.182927 3.70417 0.0457317 3.27083 0.0457317 2.7875C0.0457317 2.24583 0.19309 1.8 0.487805 1.45C0.792683 1.1 1.23476 0.870834 1.81402 0.762501V0H3.18598V0.762501C3.77541 0.8625 4.22256 1.09167 4.52744 1.45C4.83232 1.8 4.98476 2.25417 4.98476 2.8125V3.0625H3.39939V2.725C3.39939 2.20833 3.11992 1.95 2.56098 1.95C2.00203 1.95 1.72256 2.2 1.72256 2.7C1.72256 3 1.82419 3.27917 2.02744 3.5375C2.23069 3.7875 2.60671 4.09167 3.15549 4.45C3.83638 4.9 4.31402 5.32083 4.58841 5.7125C4.86281 6.09583 5 6.5375 5 7.0375C5 7.60417 4.84248 8.07083 4.52744 8.4375C4.22256 8.79583 3.77541 9.025 3.18598 9.125V10H1.81402V9.125Z"
          fill="#9C94FF"
        />
      </svg>
    ),
    TopDataDaily: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 2H17V0H15V2H5V0H3V2H2C0.9 2 0 2.9 0 4V20C0 21.1 0.9 22 2 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 20H2V9H18V20ZM18 7H2V4H18V7Z"
          fill="#CCCCCC"
        />
      </svg>
    ),
    NotificationSVG: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 19.75C9.1 19.75 10 18.85 10 17.75H6C6 18.85 6.9 19.75 8 19.75ZM14 13.75V8.75C14 5.68 12.37 3.11 9.5 2.43V1.75C9.5 0.92 8.83 0.25 8 0.25C7.17 0.25 6.5 0.92 6.5 1.75V2.43C3.64 3.11 2 5.67 2 8.75V13.75L0 15.75V16.75H16V15.75L14 13.75ZM12 14.75H4V8.75C4 6.27 5.51 4.25 8 4.25C10.49 4.25 12 6.27 12 8.75V14.75Z"
          fill="#CCCCCC"
        />
      </svg>
    ),
    // account
    AccountEdit: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.0585 9.02L14.9785 9.94L5.91854 19H4.99854V18.08L14.0585 9.02ZM17.6585 3C17.4085 3 17.1485 3.1 16.9585 3.29L15.1285 5.12L18.8785 8.87L20.7085 7.04C21.0985 6.65 21.0985 6.02 20.7085 5.63L18.3685 3.29C18.1685 3.09 17.9185 3 17.6585 3ZM14.0585 6.19L2.99854 17.25V21H6.74854L17.8085 9.94L14.0585 6.19Z"
          fill="#CCCCCC"
        />
      </svg>
    ),
    AccountDollar: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.02337 15.875C2.04099 15.7084 1.28726 15.3264 0.762195 14.7292C0.254065 14.132 0 13.3681 0 12.4375V11.4792H2.64228V12.5834C2.64228 13.4306 3.125 13.8542 4.09045 13.8542C5.05589 13.8542 5.53862 13.4167 5.53862 12.5417C5.53862 12 5.36924 11.5139 5.03049 11.0834C4.69173 10.6389 4.06504 10.125 3.15041 9.54169C2.01558 8.80558 1.21951 8.11808 0.762195 7.47919C0.304878 6.8403 0.0762195 6.11808 0.0762195 5.31252C0.0762195 4.40974 0.321816 3.66669 0.813009 3.08335C1.32114 2.50002 2.05793 2.11808 3.02337 1.93752V0.666687H5.30996V1.93752C6.29234 2.10419 7.0376 2.48613 7.54573 3.08335C8.05386 3.66669 8.30793 4.42363 8.30793 5.35419V5.77085H5.66565V5.20835C5.66565 4.34724 5.19986 3.91669 4.26829 3.91669C3.33672 3.91669 2.87093 4.33335 2.87093 5.16669C2.87093 5.66669 3.04031 6.13196 3.37907 6.56252C3.71782 6.97919 4.34451 7.48613 5.25915 8.08335C6.39397 8.83335 7.19004 9.53474 7.64736 10.1875C8.10467 10.8264 8.33333 11.5625 8.33333 12.3959C8.33333 13.3403 8.0708 14.1181 7.54573 14.7292C7.0376 15.3264 6.29234 15.7084 5.30996 15.875V17.3334H3.02337V15.875Z"
          fill="#9C94FF"
        />
      </svg>
    ),
    EnterArrow: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z"
          fill="#CCCCCC"
        />
      </svg>
    ),
    AccountTicketsIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M20.5 7.28V5C20.5 3.9 19.6 3 18.5 3H4.5C3.39 3 2.5 3.9 2.5 5V19C2.5 20.1 3.39 21 4.5 21H18.5C19.6 21 20.5 20.1 20.5 19V16.72C21.09 16.37 21.5 15.74 21.5 15V9C21.5 8.26 21.09 7.63 20.5 7.28ZM19.5 9V15H12.5V9H19.5ZM4.5 19V5H18.5V7H12.5C11.4 7 10.5 7.9 10.5 9V15C10.5 16.1 11.4 17 12.5 17H18.5V19H4.5Z" />
        <path
          d="M15.5 13.5C16.3284 13.5 17 12.8284 17 12C17 11.1716 16.3284 10.5 15.5 10.5C14.6716 10.5 14 11.1716 14 12C14 12.8284 14.6716 13.5 15.5 13.5Z"
          fill="#A6A9B8"
        />
      </svg>
    ),
    AccountVouchersIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1996_3654)">
          <path
            d="M1.95278 8.4481L10.4988 2.23906L19.0448 8.4481L15.7805 18.4945H5.21707L1.95278 8.4481Z"
            stroke="#A7AFBC"
            strokeWidth="1.5"
          />
          <path
            d="M7.34345 10.1991L10.5009 7.90508L13.6584 10.1991L12.4523 13.9109H8.54949L7.34345 10.1991Z"
            stroke="#A7AFBC"
            strokeWidth="1.5"
          />
          <line
            x1="10.543"
            y1="2.1875"
            x2="10.543"
            y2="8.51726"
            stroke="#A7AFBC"
            strokeWidth="1.5"
          />
          <line
            x1="18.8067"
            y1="8.46941"
            x2="12.7887"
            y2="10.4314"
            stroke="#A7AFBC"
            strokeWidth="1.5"
          />
          <line
            y1="-0.75"
            x2="6.32976"
            y2="-0.75"
            transform="matrix(0.950747 0.309969 0.309969 -0.950747 2.33594 7.75635)"
            stroke="#A7AFBC"
            strokeWidth="1.5"
          />
          <line
            x1="8.79291"
            y1="13.4699"
            x2="5.49831"
            y2="18.1486"
            stroke="#A7AFBC"
            strokeWidth="1.5"
          />
          <line
            y1="-0.75"
            x2="5.72228"
            y2="-0.75"
            transform="matrix(0.575749 0.817626 0.817626 -0.575749 12.5547 13.0381)"
            stroke="#A7AFBC"
            strokeWidth="1.5"
          />
        </g>
        <defs>
          <clipPath id="clip0_1996_3654">
            <rect
              width="21"
              height="21"
              fill="white"
              transform="translate(0 0.137695)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    AccountRecordIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 7H17V9H11V7ZM11 11H17V13H11V11ZM11 15H17V17H11V15ZM7 7H9V9H7V7ZM7 11H9V13H7V11ZM7 15H9V17H7V15ZM20.1 3H3.9C3.4 3 3 3.4 3 3.9V20.1C3 20.5 3.4 21 3.9 21H20.1C20.5 21 21 20.5 21 20.1V3.9C21 3.4 20.5 3 20.1 3ZM19 19H5V5H19V19Z"
          fill="#A6A9B8"
        />
      </svg>
    ),
    AccountHistoryIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.89 11.1C11.11 10.51 10.25 10.14 10.25 9.2C10.25 8.18 11.36 7.81 12.06 7.81C13.37 7.81 13.85 8.8 13.96 9.15L15.54 8.48C15.39 8.03 14.72 6.56 13 6.24V5H11V6.26C8.52 6.82 8.51 9.12 8.51 9.22C8.51 11.49 10.76 12.13 11.86 12.53C13.44 13.09 14.14 13.6 14.14 14.56C14.14 15.69 13.09 16.17 12.16 16.17C10.34 16.17 9.82 14.3 9.76 14.08L8.1 14.75C8.73 16.94 10.38 17.53 11 17.71V19H13V17.76C13.4 17.67 15.9 17.17 15.9 14.54C15.9 13.15 15.29 11.93 12.89 11.1ZM3 21H1V15H7V17H4.52C6.13 19.41 8.88 21 12 21C16.97 21 21 16.97 21 12H23C23 18.08 18.08 23 12 23C8.28 23 4.99 21.15 3 18.33V21ZM1 12C1 5.92 5.92 1 12 1C15.72 1 19.01 2.85 21 5.67V3H23V9H17V7H19.48C17.87 4.59 15.12 3 12 3C7.03 3 3 7.03 3 12H1Z"
          fill="#A6A9B8"
        />
      </svg>
    ),
    AccountBankIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 11H5V18H7V11ZM13 11H11V18H13V11ZM21.5 20H2.5V22H21.5V20ZM19 11H17V18H19V11ZM12 4.26L17.21 7H6.79L12 4.26ZM12 2L2.5 7V9H21.5V7L12 2Z"
          fill="#A6A9B8"
        />
      </svg>
    ),
    AccountReferralsIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.222 19.855C12.042 20.035 11.722 20.065 11.512 19.855C11.332 19.675 11.302 19.355 11.512 19.145L14.902 15.755L13.492 14.345L10.102 17.735C9.91205 17.935 9.59204 17.925 9.39205 17.735C9.18204 17.525 9.21204 17.205 9.39205 17.025L12.782 13.635L11.372 12.225L7.98205 15.615C7.80205 15.795 7.48205 15.825 7.27205 15.615C7.08205 15.425 7.08205 15.105 7.27205 14.905L10.662 11.515L9.24204 10.105L5.85205 13.495C5.67205 13.675 5.35205 13.705 5.14205 13.495C4.95204 13.295 4.95204 12.985 5.14205 12.785L9.52205 8.405L11.392 10.265C12.342 11.215 13.982 11.205 14.932 10.265C15.912 9.28501 15.912 7.705 14.932 6.725L13.072 4.86501L13.352 4.585C14.132 3.805 15.402 3.805 16.182 4.585L20.422 8.825C21.202 9.605 21.202 10.875 20.422 11.655L12.222 19.855ZM21.832 13.075C23.392 11.515 23.392 8.985 21.832 7.415L17.592 3.175C16.032 1.615 13.502 1.615 11.932 3.175L11.652 3.455L11.372 3.175C9.81204 1.615 7.28205 1.615 5.71205 3.175L2.17205 6.715C0.752045 8.135 0.622045 10.345 1.77205 11.905L3.22205 10.455C2.83205 9.705 2.96205 8.755 3.59205 8.125L7.13205 4.585C7.91205 3.805 9.18204 3.805 9.96204 4.585L13.522 8.14501C13.702 8.32501 13.732 8.64501 13.522 8.85501C13.312 9.06501 12.992 9.03501 12.812 8.85501L9.52205 5.57501L3.72205 11.365C2.74205 12.335 2.74205 13.925 3.72205 14.905C4.11205 15.295 4.61205 15.535 5.14205 15.605C5.21205 16.125 5.44205 16.625 5.84205 17.025C6.24205 17.425 6.74205 17.655 7.26205 17.725C7.33205 18.245 7.56205 18.745 7.96205 19.145C8.36205 19.545 8.86204 19.775 9.38204 19.845C9.45204 20.385 9.69204 20.875 10.082 21.265C10.552 21.735 11.182 21.995 11.852 21.995C12.522 21.995 13.152 21.735 13.622 21.265L21.832 13.075Z"
          fill="#A6A9B8"
        />
      </svg>
    ),
    ReferralsDiamond: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.48118 3.82878e-09H5.94672C5.99616 -8.6831e-06 6.04489 0.0147647 6.08894 0.0431127C6.13299 0.0714606 6.1711 0.112578 6.20017 0.163105L7.39785 2.24388C7.41914 2.2809 7.42962 2.32611 7.42751 2.3718C7.4254 2.41749 7.41082 2.46084 7.38626 2.49448L3.82893 7.36427C3.81426 7.3843 3.79648 7.40028 3.77669 7.41121C3.75691 7.42214 3.73555 7.42778 3.71395 7.42778C3.69236 7.42778 3.671 7.42214 3.65121 7.41121C3.63143 7.40028 3.61364 7.3843 3.59898 7.36427L0.0416456 2.49487C0.0170062 2.46121 0.00238034 2.41778 0.000266203 2.372C-0.00184793 2.32622 0.00868085 2.28094 0.0300541 2.24388L1.22774 0.163105C1.2568 0.112578 1.29492 0.0714606 1.33897 0.0431127C1.38302 0.0147647 1.43175 -8.6831e-06 1.48118 3.82878e-09Z"
          fill="#42E0A7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.11133 6.76621L6.32342 8.42536C6.33809 8.44539 6.35587 8.46137 6.37566 8.4723C6.39544 8.48323 6.4168 8.48887 6.4384 8.48887C6.45999 8.48887 6.48135 8.48323 6.50114 8.4723C6.52092 8.46137 6.53871 8.44539 6.55337 8.42536L10.1107 3.55557C10.1353 3.52194 10.1498 3.47858 10.152 3.43289C10.1541 3.3872 10.1436 3.342 10.1223 3.30498L8.92461 1.2242C8.89555 1.17367 8.85743 1.13256 8.81338 1.10421C8.76933 1.07586 8.7206 1.06109 8.67117 1.0611H7.56259L8.24339 2.24387C8.26468 2.28089 8.27516 2.32609 8.27305 2.37178C8.27093 2.41747 8.25636 2.46082 8.2318 2.49446L5.11133 6.76621Z"
          fill="#42E0A7"
        />
      </svg>
    ),
    AccountSettingsIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.4323 12.98C19.4723 12.66 19.5023 12.34 19.5023 12C19.5023 11.66 19.4723 11.34 19.4323 11.02L21.5423 9.37C21.7323 9.22 21.7823 8.95 21.6623 8.73L19.6623 5.27C19.5723 5.11 19.4023 5.02 19.2223 5.02C19.1623 5.02 19.1023 5.03 19.0523 5.05L16.5623 6.05C16.0423 5.65 15.4823 5.32 14.8723 5.07L14.4923 2.42C14.4623 2.18 14.2523 2 14.0023 2H10.0023C9.75228 2 9.54228 2.18 9.51228 2.42L9.13228 5.07C8.52228 5.32 7.96228 5.66 7.44228 6.05L4.95228 5.05C4.89228 5.03 4.83228 5.02 4.77228 5.02C4.60228 5.02 4.43228 5.11 4.34228 5.27L2.34228 8.73C2.21228 8.95 2.27228 9.22 2.46228 9.37L4.57228 11.02C4.53228 11.34 4.50228 11.67 4.50228 12C4.50228 12.33 4.53228 12.66 4.57228 12.98L2.46228 14.63C2.27228 14.78 2.22228 15.05 2.34228 15.27L4.34228 18.73C4.43228 18.89 4.60228 18.98 4.78228 18.98C4.84228 18.98 4.90228 18.97 4.95228 18.95L7.44228 17.95C7.96228 18.35 8.52228 18.68 9.13228 18.93L9.51228 21.58C9.54228 21.82 9.75228 22 10.0023 22H14.0023C14.2523 22 14.4623 21.82 14.4923 21.58L14.8723 18.93C15.4823 18.68 16.0423 18.34 16.5623 17.95L19.0523 18.95C19.1123 18.97 19.1723 18.98 19.2323 18.98C19.4023 18.98 19.5723 18.89 19.6623 18.73L21.6623 15.27C21.7823 15.05 21.7323 14.78 21.5423 14.63L19.4323 12.98ZM17.4523 11.27C17.4923 11.58 17.5023 11.79 17.5023 12C17.5023 12.21 17.4823 12.43 17.4523 12.73L17.3123 13.86L18.2023 14.56L19.2823 15.4L18.5823 16.61L17.3123 16.1L16.2723 15.68L15.3723 16.36C14.9423 16.68 14.5323 16.92 14.1223 17.09L13.0623 17.52L12.9023 18.65L12.7023 20H11.3023L10.9523 17.52L9.89228 17.09C9.46228 16.91 9.06228 16.68 8.66228 16.38L7.75228 15.68L6.69228 16.11L5.42228 16.62L4.72228 15.41L5.80228 14.57L6.69228 13.87L6.55228 12.74C6.52228 12.43 6.50228 12.2 6.50228 12C6.50228 11.8 6.52228 11.57 6.55228 11.27L6.69228 10.14L5.80228 9.44L4.72228 8.6L5.42228 7.39L6.69228 7.9L7.73228 8.32L8.63228 7.64C9.06228 7.32 9.47228 7.08 9.88228 6.91L10.9423 6.48L11.1023 5.35L11.3023 4H12.6923L13.0423 6.48L14.1023 6.91C14.5323 7.09 14.9323 7.32 15.3323 7.62L16.2423 8.32L17.3023 7.89L18.5723 7.38L19.2723 8.59L18.2023 9.44L17.3123 10.14L17.4523 11.27ZM12.0023 8C9.79228 8 8.00228 9.79 8.00228 12C8.00228 14.21 9.79228 16 12.0023 16C14.2123 16 16.0023 14.21 16.0023 12C16.0023 9.79 14.2123 8 12.0023 8ZM12.0023 14C10.9023 14 10.0023 13.1 10.0023 12C10.0023 10.9 10.9023 10 12.0023 10C13.1023 10 14.0023 10.9 14.0023 12C14.0023 13.1 13.1023 14 12.0023 14Z"
          fill="#A6A9B8"
        />
      </svg>
    ),
    AccountHelpIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 18H13V16H11V18ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z"
          fill="#A6A9B8"
        />
      </svg>
    ),
    AccountFeedbackIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.5086 3.92114V5.00022C12.5086 5.07108 12.4947 5.14124 12.4676 5.2067C12.4405 5.27216 12.4007 5.33164 12.3506 5.38174C12.3005 5.43184 12.241 5.47158 12.1756 5.4987C12.1101 5.52581 12.04 5.53977 11.9691 5.53977H4.96042V18.5363L18.9432 18.4813V12.5776C18.9432 12.5067 18.9572 12.4366 18.9843 12.3711C19.0114 12.3056 19.0512 12.2462 19.1013 12.1961C19.1514 12.146 19.2109 12.1062 19.2763 12.0791C19.3418 12.052 19.4119 12.038 19.4828 12.038H20.5619C20.6327 12.038 20.7029 12.052 20.7684 12.0791C20.8338 12.1062 20.8933 12.146 20.9434 12.1961C20.9935 12.2462 21.0332 12.3056 21.0604 12.3711C21.0875 12.4366 21.1014 12.5067 21.1014 12.5776V19.0543C21.1014 19.8776 20.4723 20.5542 19.6695 20.6319L19.5162 20.6395L4.38743 20.6934C3.563 20.6934 2.88641 20.0654 2.80872 19.2615L2.80225 19.1093V4.96677C2.80225 4.14235 3.43028 3.46576 4.2342 3.38915L4.38635 3.38159H11.9691C12.04 3.38159 12.1101 3.39555 12.1756 3.42266C12.241 3.44978 12.3005 3.48952 12.3506 3.53962C12.4007 3.58972 12.4405 3.6492 12.4676 3.71466C12.4947 3.78012 12.5086 3.85028 12.5086 3.92114Z"
          fill="#A6A9B8"
        />
        <path
          d="M21.0829 5.05283L14.6949 11.3484C14.6053 11.4365 14.4873 11.4911 14.3613 11.5026C13.5767 11.5744 13.142 11.568 13.0561 11.4834C12.9692 11.3987 12.954 10.9618 13.0061 10.1713C13.0151 10.0419 13.0715 9.92014 13.1648 9.8286L19.5462 3.53838C19.6481 3.43799 19.7863 3.38159 19.9304 3.38159C20.0744 3.38159 20.2126 3.43799 20.3145 3.53838L21.0829 4.29561C21.1847 4.39603 21.242 4.53222 21.242 4.67422C21.242 4.81622 21.1847 4.95241 21.0829 5.05283Z"
          fill="#A6A9B8"
        />
      </svg>
    ),
    AccountLogoutIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.4323 12.98C19.4723 12.66 19.5023 12.34 19.5023 12C19.5023 11.66 19.4723 11.34 19.4323 11.02L21.5423 9.37C21.7323 9.22 21.7823 8.95 21.6623 8.73L19.6623 5.27C19.5723 5.11 19.4023 5.02 19.2223 5.02C19.1623 5.02 19.1023 5.03 19.0523 5.05L16.5623 6.05C16.0423 5.65 15.4823 5.32 14.8723 5.07L14.4923 2.42C14.4623 2.18 14.2523 2 14.0023 2H10.0023C9.75228 2 9.54228 2.18 9.51228 2.42L9.13228 5.07C8.52228 5.32 7.96228 5.66 7.44228 6.05L4.95228 5.05C4.89228 5.03 4.83228 5.02 4.77228 5.02C4.60228 5.02 4.43228 5.11 4.34228 5.27L2.34228 8.73C2.21228 8.95 2.27228 9.22 2.46228 9.37L4.57228 11.02C4.53228 11.34 4.50228 11.67 4.50228 12C4.50228 12.33 4.53228 12.66 4.57228 12.98L2.46228 14.63C2.27228 14.78 2.22228 15.05 2.34228 15.27L4.34228 18.73C4.43228 18.89 4.60228 18.98 4.78228 18.98C4.84228 18.98 4.90228 18.97 4.95228 18.95L7.44228 17.95C7.96228 18.35 8.52228 18.68 9.13228 18.93L9.51228 21.58C9.54228 21.82 9.75228 22 10.0023 22H14.0023C14.2523 22 14.4623 21.82 14.4923 21.58L14.8723 18.93C15.4823 18.68 16.0423 18.34 16.5623 17.95L19.0523 18.95C19.1123 18.97 19.1723 18.98 19.2323 18.98C19.4023 18.98 19.5723 18.89 19.6623 18.73L21.6623 15.27C21.7823 15.05 21.7323 14.78 21.5423 14.63L19.4323 12.98ZM17.4523 11.27C17.4923 11.58 17.5023 11.79 17.5023 12C17.5023 12.21 17.4823 12.43 17.4523 12.73L17.3123 13.86L18.2023 14.56L19.2823 15.4L18.5823 16.61L17.3123 16.1L16.2723 15.68L15.3723 16.36C14.9423 16.68 14.5323 16.92 14.1223 17.09L13.0623 17.52L12.9023 18.65L12.7023 20H11.3023L10.9523 17.52L9.89228 17.09C9.46228 16.91 9.06228 16.68 8.66228 16.38L7.75228 15.68L6.69228 16.11L5.42228 16.62L4.72228 15.41L5.80228 14.57L6.69228 13.87L6.55228 12.74C6.52228 12.43 6.50228 12.2 6.50228 12C6.50228 11.8 6.52228 11.57 6.55228 11.27L6.69228 10.14L5.80228 9.44L4.72228 8.6L5.42228 7.39L6.69228 7.9L7.73228 8.32L8.63228 7.64C9.06228 7.32 9.47228 7.08 9.88228 6.91L10.9423 6.48L11.1023 5.35L11.3023 4H12.6923L13.0423 6.48L14.1023 6.91C14.5323 7.09 14.9323 7.32 15.3323 7.62L16.2423 8.32L17.3023 7.89L18.5723 7.38L19.2723 8.59L18.2023 9.44L17.3123 10.14L17.4523 11.27ZM12.0023 8C9.79228 8 8.00228 9.79 8.00228 12C8.00228 14.21 9.79228 16 12.0023 16C14.2123 16 16.0023 14.21 16.0023 12C16.0023 9.79 14.2123 8 12.0023 8ZM12.0023 14C10.9023 14 10.0023 13.1 10.0023 12C10.0023 10.9 10.9023 10 12.0023 10C13.1023 10 14.0023 10.9 14.0023 12C14.0023 13.1 13.1023 14 12.0023 14Z"
          fill="#A6A9B8"
        />
      </svg>
    ),
    // billion
    BillionJoinSuccessIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM12.5 20C8.09 20 4.5 16.41 4.5 12C4.5 7.59 8.09 4 12.5 4C16.91 4 20.5 7.59 20.5 12C20.5 16.41 16.91 20 12.5 20ZM17.09 7.58L10.5 14.17L7.91 11.59L6.5 13L10.5 17L18.5 9L17.09 7.58Z"
          fill="#42E05C"
        />
      </svg>
    ),
    BillionAddIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="44" rx="22" />
        <path d="M29 23H23V29H21V23H15V21H21V15H23V21H29V23Z" fill="black" />
      </svg>
    ),
    // joinedGames & upcoming
    ClockIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M9.00002 0.666687C4.41669 0.666687 0.666687 4.41669 0.666687 9.00002C0.666687 13.5834 4.41669 17.3334 9.00002 17.3334C13.5834 17.3334 17.3334 13.5834 17.3334 9.00002C17.3334 4.41669 13.5834 0.666687 9.00002 0.666687ZM9.00002 15.6667C5.32502 15.6667 2.33335 12.675 2.33335 9.00002C2.33335 5.32502 5.32502 2.33335 9.00002 2.33335C12.675 2.33335 15.6667 5.32502 15.6667 9.00002C15.6667 12.675 12.675 15.6667 9.00002 15.6667ZM9.41669 4.83335H8.16669V9.83335L12.5 12.5L13.1667 11.4167L9.41669 9.16669V4.83335Z" />
      </svg>
    ),
    SortDownArrow: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <circle cx="7" cy="7" r="7" />
        <path
          d="M10.5 7L9.88313 6.38313L7.4375 8.82438V3.5H6.5625V8.82438L4.12125 6.37875L3.5 7L7 10.5L10.5 7Z"
          fill="black"
        />
      </svg>
    ),
    SortPriceIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M9.00002 0.666687C4.40002 0.666687 0.666687 4.40002 0.666687 9.00002C0.666687 13.6 4.40002 17.3334 9.00002 17.3334C13.6 17.3334 17.3334 13.6 17.3334 9.00002C17.3334 4.40002 13.6 0.666687 9.00002 0.666687ZM9.00002 15.6667C5.32502 15.6667 2.33335 12.675 2.33335 9.00002C2.33335 5.32502 5.32502 2.33335 9.00002 2.33335C12.675 2.33335 15.6667 5.32502 15.6667 9.00002C15.6667 12.675 12.675 15.6667 9.00002 15.6667ZM9.25835 8.28335C7.78335 7.90835 7.30835 7.50002 7.30835 6.89169C7.30835 6.19169 7.96669 5.70002 9.05835 5.70002C10.2084 5.70002 10.6417 6.25002 10.675 7.06669H12.1C12.0584 5.95002 11.375 4.92502 10.025 4.59169V3.16669H8.08335V4.57502C6.82502 4.84169 5.81669 5.65835 5.81669 6.91669C5.81669 8.40835 7.05835 9.15835 8.86669 9.59169C10.4917 9.97502 10.8167 10.55 10.8167 11.15C10.8167 11.5917 10.4917 12.3084 9.06669 12.3084C7.73335 12.3084 7.20835 11.7084 7.13335 10.9417H5.70002C5.78335 12.3584 6.83335 13.1584 8.08335 13.4167V14.8334H10.0334V13.4417C11.3 13.2 12.3 12.475 12.3084 11.1334C12.3 9.30002 10.725 8.66669 9.25835 8.28335Z" />
      </svg>
    ),
    JoinGameSuccessIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 18C6.09 18 2.5 14.41 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 14.41 14.91 18 10.5 18ZM15.09 5.58L8.5 12.17L5.91 9.59L4.5 11L8.5 15L16.5 7L15.09 5.58Z" />
      </svg>
    ),
    JoinGameAddIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" />
      </svg>
    ),
    // chatItem
    MoreIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm4 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm4 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"></path>
      </svg>
    ),
    SmileIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <g>
          <path d="M6 1.2C3.3 1.2 1.2 3.3 1.2 6c0 2.7 2.1 4.8 4.8 4.8 2.7 0 4.8-2.1 4.8-4.8 0-2.7-2.1-4.8-4.8-4.8zM0 6c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6-6-2.7-6-6z"></path>
          <path d="M5.4 4.5c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9zM8.4 4.5c0 .5-.4.9-.9.9s-.9-.4-.9-.9.4-.9.9-.9.9.4.9.9zM3.3 6.7c.3-.2.6-.1.8.1.3.4.8.9 1.5 1 .6.2 1.4.1 2.4-1 .2-.2.6-.3.8 0 .2.2.3.6 0 .8-1.1 1.3-2.4 1.7-3.5 1.5-1-.2-1.8-.9-2.2-1.5-.2-.3-.1-.7.2-.9z"></path>
        </g>
      </svg>
    ),
    CurrentIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M8.9999 16.2L4.7999 12L3.3999 13.4L8.9999 19L20.9999 6.99998L19.5999 5.59998L8.9999 16.2Z"></path>
      </svg>
    ),
    // account component
    VerifyIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_341_6605)">
          <path
            d="M71.0813 40.4478C62.1269 36.468 53.0466 36.468 44.0921 40.4478C43.5336 40.696 43.1736 41.2501 43.1736 41.8614V50.655C43.1736 59.8188 48.5846 68.1449 56.9583 71.8667C57.1583 71.9556 57.3725 72 57.5867 72C57.8008 72 58.0149 71.9556 58.215 71.8667C66.5889 68.1448 71.9999 59.8188 71.9999 50.655V41.8614C71.9999 41.2499 71.6399 40.696 71.0813 40.4478ZM68.9061 50.655C68.9061 58.3657 64.4856 65.3923 57.5867 68.7473C50.6877 65.3923 46.2673 58.3657 46.2673 50.655V42.8822C53.7839 39.7963 61.3896 39.7963 68.9061 42.8822V50.655Z"
            fill="#9C94FF"
          />
          <path
            d="M54.1318 53.6338C53.5275 53.0297 52.5483 53.0297 51.9441 53.6338C51.3399 54.2379 51.3399 55.2174 51.9441 55.8215L54.9766 58.8541C55.2787 59.1562 55.6746 59.3072 56.0704 59.3072C56.4663 59.3072 56.8621 59.1562 57.1642 58.8541L63.2295 52.7888C63.8336 52.1847 63.8336 51.2052 63.2295 50.6011C62.6252 49.997 61.6461 49.997 61.0418 50.6011L56.0703 55.5726L54.1318 53.6338Z"
            fill="#9C94FF"
          />
          <path
            d="M37.404 38.7162V37.1232C37.404 32.5741 34.7224 28.641 30.8579 26.8171C32.247 25.4929 33.1152 23.6271 33.1152 21.5612C33.1152 17.5551 29.8561 14.296 25.8499 14.296C21.8438 14.296 18.5847 17.5551 18.5847 21.5612C18.5847 23.6271 19.4529 25.4931 20.842 26.8171C16.9775 28.641 14.2959 32.5741 14.2959 37.1232V38.7162C14.2959 39.5705 14.9885 40.2631 15.8428 40.2631H35.8571C36.7115 40.2631 37.404 39.5706 37.404 38.7162ZM25.8501 17.3897C28.1501 17.3897 30.0216 19.261 30.0216 21.5612C30.0216 23.8613 28.1503 25.7327 25.8501 25.7327C23.5499 25.7327 21.6786 23.8614 21.6786 21.5612C21.6786 19.261 23.5499 17.3897 25.8501 17.3897ZM34.3102 37.1693H17.3898V37.1232C17.3898 32.5482 21.1117 28.8263 25.6867 28.8263H26.0135C30.5884 28.8263 34.3104 32.5482 34.3104 37.1232L34.3102 37.1693Z"
            fill="#CCCCCC"
          />
          <path
            d="M17.2725 57.4182H34.4276C35.2819 57.4182 35.9745 56.7256 35.9745 55.8713C35.9745 55.017 35.2819 54.3244 34.4276 54.3244H17.2725C16.4182 54.3244 15.7256 55.017 15.7256 55.8713C15.7256 56.7256 16.418 57.4182 17.2725 57.4182Z"
            fill="#CCCCCC"
          />
          <path
            d="M51.6999 38.0292V15.8428C51.6998 15.4365 51.5346 15.0363 51.2468 14.749L36.9509 0.453094C36.6636 0.165234 36.2632 0.0005625 35.8571 0H5.83566C2.61787 0 0 2.61788 0 5.83566V60.1601C0 63.3779 2.61787 65.9957 5.83566 65.9957H48.9712C48.1206 65.0291 47.3543 63.9932 46.6762 62.902H5.83566C4.3238 62.902 3.09375 61.6719 3.09375 60.1601V5.83566C3.09375 4.3238 4.3238 3.09375 5.83566 3.09375H34.3101V11.554C34.3101 14.7718 36.928 17.3897 40.1458 17.3897H48.606V38.7842C49.6364 38.481 50.6677 38.2278 51.6999 38.0292ZM40.1458 14.2959C38.6339 14.2959 37.4039 13.0659 37.4039 11.554V5.28131L46.4185 14.2959H40.1458Z"
            fill="#CCCCCC"
          />
          <path
            d="M17.2729 48.8406C18.1273 48.8406 18.8198 48.148 18.8198 47.2937C18.8198 46.4394 18.1273 45.7468 17.2729 45.7468C16.4186 45.7468 15.7261 46.4394 15.7261 47.2937C15.7261 48.148 16.4186 48.8406 17.2729 48.8406Z"
            fill="#CCCCCC"
          />
          <path
            d="M25.8496 48.8406C26.7039 48.8406 27.3965 48.148 27.3965 47.2937C27.3965 46.4394 26.7039 45.7468 25.8496 45.7468C24.9953 45.7468 24.3027 46.4394 24.3027 47.2937C24.3027 48.148 24.9953 48.8406 25.8496 48.8406Z"
            fill="#CCCCCC"
          />
          <path
            d="M34.4278 48.8405C35.2821 48.8405 35.9746 48.148 35.9746 47.2937C35.9746 46.4395 35.2821 45.747 34.4278 45.747C33.5736 45.747 32.8811 46.4395 32.8811 47.2937C32.8811 48.148 33.5736 48.8405 34.4278 48.8405Z"
            fill="#CCCCCC"
          />
        </g>
        <defs>
          <clipPath id="clip0_341_6605">
            <rect width="72" height="72" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    VerifySelfIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H4V7H8.05L9.88 5H14.12L15.95 7H20V19Z"
          fill="#A6A9B8"
        />
        <path
          d="M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z"
          fill="#A6A9B8"
        />
        <path
          d="M14.78 14.58C13.93 14.21 12.99 14 12 14C11.01 14 10.07 14.21 9.22 14.58C8.48 14.9 8 15.62 8 16.43V17H16V16.43C16 15.62 15.52 14.9 14.78 14.58Z"
          fill="#A6A9B8"
        />
      </svg>
    ),
    UploadIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M18 15V18H6V15H4V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V15H18ZM7 9L8.41 10.41L11 7.83V16H13V7.83L15.59 10.41L17 9L12 4L7 9Z" />
      </svg>
    ),
    DriverIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M18.92 5.01C18.72 4.42 18.16 4 17.5 4H6.5C5.84 4 5.29 4.42 5.08 5.01L3 11V19C3 19.55 3.45 20 4 20H5C5.55 20 6 19.55 6 19V18H18V19C18 19.55 18.45 20 19 20H20C20.55 20 21 19.55 21 19V11L18.92 5.01ZM6.85 6H17.14L18.18 9H5.81L6.85 6ZM19 16H5V11.34L5.12 11H18.89L19 11.34V16Z" />
        <path d="M7.5 15C8.32843 15 9 14.3284 9 13.5C9 12.6716 8.32843 12 7.5 12C6.67157 12 6 12.6716 6 13.5C6 14.3284 6.67157 15 7.5 15Z" />
        <path d="M16.5 15C17.3284 15 18 14.3284 18 13.5C18 12.6716 17.3284 12 16.5 12C15.6716 12 15 12.6716 15 13.5C15 14.3284 15.6716 15 16.5 15Z" />
      </svg>
    ),
    PassportIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <rect
          x="5"
          y="3"
          width="14"
          height="20"
          rx="1"
          stroke="#A6A9B8"
          strokeWidth="2"
        />
        <path
          d="M11.9998 6C9.11166 6 6.76172 8.34994 6.76172 11.2381C6.76172 14.1263 9.11166 16.4762 11.9998 16.4762C14.888 16.4762 17.2379 14.1263 17.2379 11.2381C17.2379 8.34994 14.888 6 11.9998 6ZM15.8695 10.5833H14.5979C14.5409 9.61363 14.3596 8.67339 14.0571 7.8975C14.9999 8.48024 15.6776 9.44929 15.8695 10.5833ZM11.9998 15.1667C11.5814 15.1667 10.8533 13.9344 10.7184 11.8929H13.2812C13.1463 13.9344 12.4182 15.1667 11.9998 15.1667ZM10.7184 10.5833C10.8533 8.54179 11.5814 7.30952 11.9998 7.30952C12.4182 7.30952 13.1463 8.54179 13.2812 10.5833H10.7184ZM9.94255 7.8975C9.64005 8.67339 9.45868 9.61363 9.40172 10.5833H8.13017C8.32202 9.44929 8.99969 8.48024 9.94255 7.8975ZM8.13017 11.8929H9.40172C9.45868 12.8626 9.64005 13.8028 9.94255 14.5787C8.99969 13.996 8.32202 13.0269 8.13017 11.8929ZM14.0571 14.5787C14.3596 13.8028 14.5409 12.8626 14.5979 11.8929H15.8695C15.6776 13.0269 14.9999 13.996 14.0571 14.5787ZM15.9284 19.0952C15.9284 19.4567 15.6357 19.75 15.2736 19.75H8.726C8.36392 19.75 8.07124 19.4567 8.07124 19.0952C8.07124 18.7338 8.36392 18.4405 8.726 18.4405H15.2736C15.6357 18.4405 15.9284 18.7338 15.9284 19.0952Z"
          fill="#A6A9B8"
        />
      </svg>
    ),
    PermanentResidentIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M18 9H14V10.5H18V9Z" fill="#A6A9B8" />
        <path d="M18 12H14V13.5H18V12Z" fill="#A6A9B8" />
        <path
          d="M9 12C9.82843 12 10.5 11.3284 10.5 10.5C10.5 9.67157 9.82843 9 9 9C8.17157 9 7.5 9.67157 7.5 10.5C7.5 11.3284 8.17157 12 9 12Z"
          fill="#A6A9B8"
        />
        <path
          d="M11.08 13.18C10.44 12.9 9.74 12.75 9 12.75C8.26 12.75 7.56 12.9 6.92 13.18C6.36 13.42 6 13.96 6 14.57V15H12V14.57C12 13.96 11.64 13.42 11.08 13.18Z"
          fill="#A6A9B8"
        />
        <rect
          x="3"
          y="6"
          width="18"
          height="12"
          rx="1"
          stroke="#A6A9B8"
          strokeWidth="2"
        />
      </svg>
    ),
    MilitaryIdCardIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M18 12H14V13.5H18V12Z" fill="#A6A9B8" />
        <path d="M18 15H14V16.5H18V15Z" fill="#A6A9B8" />
        <path
          d="M20 7H15V4C15 2.9 14.1 2 13 2H11C9.9 2 9 2.9 9 4V7H4C2.9 7 2 7.9 2 9V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V9C22 7.9 21.1 7 20 7ZM11 4H13V9H11V4ZM20 20H4V9H9C9 10.1 9.9 11 11 11H13C14.1 11 15 10.1 15 9H20V20Z"
          fill="#A6A9B8"
        />
        <path
          d="M9 15C9.82843 15 10.5 14.3284 10.5 13.5C10.5 12.6716 9.82843 12 9 12C8.17157 12 7.5 12.6716 7.5 13.5C7.5 14.3284 8.17157 15 9 15Z"
          fill="#A6A9B8"
        />
        <path
          d="M11.08 16.18C10.44 15.9 9.74 15.75 9 15.75C8.26 15.75 7.56 15.9 6.92 16.18C6.36 16.42 6 16.96 6 17.57V18H12V17.57C12 16.96 11.64 16.42 11.08 16.18Z"
          fill="#A6A9B8"
        />
      </svg>
    ),
    // transaction history
    TransactionHistorySortIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" />
      </svg>
    ),
    PigsIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="44" rx="22" fill="#434958" />
        <path
          d="M24.5003 20.7499C24.5003 20.2916 24.8753 19.9166 25.3337 19.9166C25.792 19.9166 26.167 20.2916 26.167 20.7499C26.167 21.2083 25.792 21.5833 25.3337 21.5833C24.8753 21.5833 24.5003 21.2083 24.5003 20.7499ZM18.667 19.9166H22.8337V18.2499H18.667V19.9166ZM30.3337 18.6666V24.4749L27.9837 25.2583L26.5837 29.9166H22.0003V28.2499H20.3337V29.9166H15.7503C15.7503 29.9166 13.667 22.8666 13.667 20.3333C13.667 17.7999 15.717 15.7499 18.2503 15.7499H22.417C23.1753 14.7416 24.3837 14.0833 25.7503 14.0833C26.442 14.0833 27.0003 14.6416 27.0003 15.3333C27.0003 15.5083 26.967 15.6666 26.9003 15.8166C26.7837 16.0999 26.6837 16.4249 26.6337 16.7749L28.5253 18.6666H30.3337ZM28.667 20.3333H27.8337L24.917 17.4166C24.917 16.8749 24.992 16.3416 25.1337 15.8249C24.3253 16.0333 23.667 16.6333 23.392 17.4166H18.2503C16.642 17.4166 15.3337 18.7249 15.3337 20.3333C15.3337 21.8999 16.3503 25.8749 17.0087 28.2499H18.667V26.5833H23.667V28.2499H25.342L26.6337 23.9583L28.667 23.2749V20.3333Z"
          fill="#CCCCCC"
        />
      </svg>
    ),
    WinningsIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_343_967)">
          <path
            d="M44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44C34.1503 44 44 34.1503 44 22Z"
            fill="#434958"
          />
          <path
            d="M16.9318 22.9105V15.2569H27.0812V22.9105C27.0812 25.7132 24.8092 27.9852 22.0065 27.9852C19.2038 27.9852 16.9318 25.7132 16.9318 22.9105Z"
            stroke="#CCCCCC"
            strokeWidth="1.6"
          />
          <path
            d="M27.1577 18.8336L29.6447 18.0659L29.5464 22.2945L27.1577 23.6083"
            stroke="#CCCCCC"
            strokeWidth="1.6"
            strokeLinejoin="round"
          />
          <path
            d="M16.8423 18.8336L14.3553 18.0659L14.4536 22.2945L16.8423 23.6083"
            stroke="#CCCCCC"
            strokeWidth="1.6"
            strokeLinejoin="round"
          />
          <line
            x1="19.2905"
            y1="30.6898"
            x2="24.71"
            y2="30.6898"
            stroke="#CCCCCC"
            strokeWidth="1.6"
          />
        </g>
        <defs>
          <clipPath id="clip0_343_967">
            <rect width="44" height="44" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    TransactionTicketIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="44" rx="22" fill="#434958" />
        <path
          d="M30.3337 20.3333V16.9999C30.3337 16.0833 29.5837 15.3333 28.667 15.3333H15.3337C14.417 15.3333 13.6753 16.0833 13.6753 16.9999V20.3333C14.592 20.3333 15.3337 21.0833 15.3337 21.9999C15.3337 22.9166 14.592 23.6666 13.667 23.6666V26.9999C13.667 27.9166 14.417 28.6666 15.3337 28.6666H28.667C29.5837 28.6666 30.3337 27.9166 30.3337 26.9999V23.6666C29.417 23.6666 28.667 22.9166 28.667 21.9999C28.667 21.0833 29.417 20.3333 30.3337 20.3333ZM28.667 19.1166C27.6753 19.6916 27.0003 20.7749 27.0003 21.9999C27.0003 23.2249 27.6753 24.3083 28.667 24.8833V26.9999H15.3337V24.8833C16.3253 24.3083 17.0003 23.2249 17.0003 21.9999C17.0003 20.7666 16.3337 19.6916 15.342 19.1166L15.3337 16.9999H28.667V19.1166ZM19.5587 25.3333L22.0003 23.7666L24.442 25.3333L23.7003 22.5333L25.942 20.6999L23.0503 20.5249L22.0003 17.8333L20.942 20.5166L18.0503 20.6916L20.292 22.5249L19.5587 25.3333Z"
          fill="#CCCCCC"
        />
      </svg>
    ),
    ExternalIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="44" rx="22" fill="#434958" />
        <path
          d="M25.7497 26.1667L29.9163 22L25.7497 17.8333L24.5747 19.0083L26.7247 21.1667H19.083V22.8333H26.7247L24.5747 24.9917L25.7497 26.1667Z"
          fill="#CCCCCC"
        />
        <path
          d="M27.4163 27.8333H15.7497V16.1667H27.4163V17.8333H29.083V16.1667C29.083 15.25 28.3413 14.5 27.4163 14.5H15.7497C14.833 14.5 14.083 15.25 14.083 16.1667V27.8333C14.083 28.75 14.833 29.5 15.7497 29.5H27.4163C28.3413 29.5 29.083 28.75 29.083 27.8333V26.1667H27.4163V27.8333Z"
          fill="#CCCCCC"
        />
      </svg>
    ),
    GiftIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44C34.1503 44 44 34.1503 44 22Z"
          fill="#434958"
        />
        <g clipPath="url(#clip0_2739_5630)">
          <path
            d="M28 22V29.5H16V22"
            stroke="#CCCCCC"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.5 18.25H14.5V22H29.5V18.25Z"
            stroke="#CCCCCC"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22 29.5V18.25"
            stroke="#CCCCCC"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22 18.25H18.625C18.1277 18.25 17.6508 18.0525 17.2992 17.7008C16.9475 17.3492 16.75 16.8723 16.75 16.375C16.75 15.8777 16.9475 15.4008 17.2992 15.0492C17.6508 14.6975 18.1277 14.5 18.625 14.5C21.25 14.5 22 18.25 22 18.25Z"
            stroke="#CCCCCC"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22 18.25H25.375C25.8723 18.25 26.3492 18.0525 26.7008 17.7008C27.0525 17.3492 27.25 16.8723 27.25 16.375C27.25 15.8777 27.0525 15.4008 26.7008 15.0492C26.3492 14.6975 25.8723 14.5 25.375 14.5C22.75 14.5 22 18.25 22 18.25Z"
            stroke="#CCCCCC"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2739_5630">
            <rect
              width="18"
              height="18"
              fill="white"
              transform="translate(13 13)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    TakeASelfieIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.2925 13.6964C18.5331 13.6964 17.9175 13.0808 17.9175 12.3214V8.99951C17.9175 8.24014 18.5331 7.62451 19.2925 7.62451H22.6141C23.3735 7.62451 23.9891 8.24014 23.9891 8.99951C23.9891 9.75889 23.3735 10.3745 22.6141 10.3745H20.6675V12.3214C20.6675 13.0808 20.0519 13.6964 19.2925 13.6964Z"
          fill="#9C94FF"
        />
        <path
          d="M44.7074 13.6964C43.948 13.6964 43.3324 13.0808 43.3324 12.3214V10.3745H41.3857C40.6264 10.3745 40.0107 9.75889 40.0107 8.99951C40.0107 8.24014 40.6264 7.62451 41.3857 7.62451H44.7074C45.4667 7.62451 46.0824 8.24014 46.0824 8.99951V12.3214C46.0824 13.0808 45.4667 13.6964 44.7074 13.6964Z"
          fill="#9C94FF"
        />
        <path
          d="M22.6142 44.9389H19.2925C18.5331 44.9389 17.9175 44.3233 17.9175 43.5639V40.2419C17.9175 39.4825 18.5331 38.8669 19.2925 38.8669C20.0519 38.8669 20.6675 39.4825 20.6675 40.2419V42.1889H22.6141C23.3735 42.1889 23.9891 42.8045 23.9891 43.5639C23.9892 44.3233 23.3736 44.9389 22.6142 44.9389Z"
          fill="#9C94FF"
        />
        <path
          d="M44.7074 44.9389H41.3857C40.6264 44.9389 40.0107 44.3233 40.0107 43.5639C40.0107 42.8045 40.6264 42.1889 41.3857 42.1889H43.3324V40.2419C43.3324 39.4825 43.948 38.8669 44.7074 38.8669C45.4667 38.8669 46.0824 39.4825 46.0824 40.2419V43.5639C46.0824 44.3233 45.4667 44.9389 44.7074 44.9389Z"
          fill="#9C94FF"
        />
        <path
          d="M48.5197 0H15.4802C12.62 0 10.293 2.327 10.293 5.18725V58.8128C10.293 61.673 12.62 64 15.4802 64H48.5197C51.38 64 53.707 61.673 53.707 58.8128V5.18725C53.707 2.327 51.38 0 48.5197 0ZM15.4802 2.75H48.5197C49.8636 2.75 50.957 3.84338 50.957 5.18725V49.8134H13.043V5.18725C13.043 3.84338 14.1363 2.75 15.4802 2.75ZM48.5197 61.25H15.4802C14.1363 61.25 13.043 60.1566 13.043 58.8128V52.5634H50.957V58.8128C50.957 60.1566 49.8636 61.25 48.5197 61.25Z"
          fill="#CCCCCC"
        />
        <path
          d="M39.8153 35.4458C38.702 35.4458 37.7964 34.5401 37.7964 33.427V32.7604C38.0629 32.5122 38.3206 32.2537 38.566 31.987C40.2678 30.1375 41.1306 27.9253 41.1306 25.4119V22.7097C41.1306 20.3165 40.226 18.0904 38.5833 16.4414C36.9455 14.7974 34.7251 13.8778 32.3311 13.8518C29.9374 13.8264 27.6874 14.732 25.9974 16.4035C24.3073 18.0755 23.3764 20.315 23.3764 22.7095V25.7682C23.3764 28.6629 24.5298 31.1935 26.7108 33.0907V33.4269C26.7108 34.54 25.8051 35.4457 24.6919 35.4457C23.9325 35.4457 23.3169 36.0613 23.3169 36.8207C23.3169 37.58 23.9325 38.1957 24.6919 38.1957C26.8271 38.1957 28.6391 36.785 29.2449 34.8467C30.313 35.4124 31.336 35.7365 32.1436 35.7365C32.9818 35.7365 34.081 35.3417 35.216 34.6843C35.7693 36.7054 37.621 38.1957 39.8154 38.1957C40.5748 38.1957 41.1904 37.58 41.1904 36.8207C41.1904 36.0613 40.5746 35.4458 39.8153 35.4458ZM28.542 31.0403C26.9391 29.6584 26.1264 27.8847 26.1264 25.7683V22.7097C26.1264 21.0553 26.7674 19.5102 27.9314 18.3587C29.0788 17.2237 30.6034 16.6012 32.2318 16.6012C32.2549 16.6012 32.2783 16.6013 32.3013 16.6015C35.7671 16.6392 38.3808 19.265 38.3808 22.7095V25.4118C38.3808 27.2388 37.7794 28.7805 36.5424 30.1249C36.229 30.4654 35.905 30.7762 35.5809 31.0573C35.5451 31.085 35.5108 31.1144 35.4779 31.1454C34.048 32.3577 32.6364 32.9867 32.1436 32.9867C31.6016 32.9868 30.0823 32.3682 28.542 31.0403Z"
          fill="#CCCCCC"
        />
        <path
          d="M35.967 58.2816H28.0332C27.2738 58.2816 26.6582 57.666 26.6582 56.9066C26.6582 56.1472 27.2738 55.5316 28.0332 55.5316H35.967C36.7263 55.5316 37.342 56.1472 37.342 56.9066C37.342 57.6661 36.7263 58.2816 35.967 58.2816Z"
          fill="#CCCCCC"
        />
        <path
          d="M43.8902 26.1399H20.1099C19.3505 26.1399 18.7349 25.5243 18.7349 24.7649C18.7349 24.0055 19.3505 23.3899 20.1099 23.3899H43.8902C44.6496 23.3899 45.2652 24.0055 45.2652 24.7649C45.2652 25.5243 44.6496 26.1399 43.8902 26.1399Z"
          fill="#9C94FF"
        />
      </svg>
    ),
    AddBankAccountIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M43.437 15.4575H20.5635C19.8041 15.4575 19.1885 14.8419 19.1885 14.0825C19.1885 13.3231 19.8041 12.7075 20.5635 12.7075H43.437C44.1964 12.7075 44.812 13.3231 44.812 14.0825C44.812 14.8419 44.1964 15.4575 43.437 15.4575Z"
          fill="#9C94FF"
        />
        <path
          d="M62.625 23.082C63.3844 23.082 64 22.4664 64 21.707V14.0825C64 13.5266 63.6654 13.0255 63.152 12.8125L32.527 0.105C32.1896 -0.035 31.8105 -0.035 31.473 0.105L0.848 12.8125C0.334625 13.0255 0 13.5266 0 14.0825V21.707C0 22.4664 0.615625 23.082 1.375 23.082H5.21012V45.7469H4.04362C3.28425 45.7469 2.66863 46.3625 2.66863 47.1219V53.3714H1.375C0.615625 53.3714 0 53.987 0 54.7464V62.625C0 63.3844 0.615625 64 1.375 64H62.625C63.3844 64 64 63.3844 64 62.625V54.7464C64 53.987 63.3844 53.3714 62.625 53.3714H61.3314V47.1219C61.3314 46.3625 60.7158 45.7469 59.9564 45.7469H58.7899V23.082H62.625ZM2.75 15.0006L32 2.86363L61.25 15.0006V20.332H57.4149H49.7904H14.2096H6.58512H2.75V15.0006ZM47.249 45.7469C46.4896 45.7469 45.874 46.3625 45.874 47.1219V53.3714H18.126V47.1219C18.126 46.3625 17.5104 45.7469 16.751 45.7469H15.5846V23.082H48.4154V45.7469H47.249ZM7.96012 23.082H12.8346V45.7469H7.96012V23.082ZM5.41862 48.4969H6.58512H14.2096H15.376V53.3714H5.41862V48.4969ZM61.25 61.25H2.75V56.1214H4.04362H16.751H47.249H59.9564H61.25V61.25ZM48.624 53.3714V48.4969H49.7904H57.4149H58.5814V53.3714H48.624ZM56.0399 45.7469H51.1654V23.082H56.0399V45.7469Z"
          fill="#CCCCCC"
        />
        <path
          d="M31.9998 36.8518C30.6559 36.8518 29.5625 35.7584 29.5625 34.4145C29.5625 33.0707 30.6559 31.9773 31.9998 31.9773C33.3436 31.9773 34.437 33.0707 34.437 34.4145C34.437 35.1739 35.0526 35.7895 35.812 35.7895C36.5714 35.7895 37.187 35.1739 37.187 34.4145C37.187 32.0303 35.5696 30.0179 33.3748 29.4137V28.0608C33.3748 27.3014 32.7591 26.6858 31.9998 26.6858C31.2404 26.6858 30.6248 27.3014 30.6248 28.0608V29.4137C28.4299 30.0179 26.8125 32.0303 26.8125 34.4145C26.8125 37.2748 29.1395 39.6018 31.9998 39.6018C33.3436 39.6018 34.437 40.6952 34.437 42.0389C34.437 43.3828 33.3436 44.4762 31.9998 44.4762C30.6559 44.4762 29.5625 43.3828 29.5625 42.0389C29.5625 41.2795 28.9469 40.6639 28.1875 40.6639C27.4281 40.6639 26.8125 41.2795 26.8125 42.0389C26.8125 44.4232 28.4299 46.4355 30.6248 47.0398V48.3927C30.6248 49.152 31.2404 49.7677 31.9998 49.7677C32.7591 49.7677 33.3748 49.152 33.3748 48.3927V47.0398C35.5696 46.4355 37.187 44.4232 37.187 42.0389C37.187 39.1787 34.86 36.8518 31.9998 36.8518Z"
          fill="#9C94FF"
        />
      </svg>
    ),
    PlayIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <circle
          cx="21.0002"
          cy="20.8251"
          r="20.1331"
          fill="black"
          fillOpacity="0.4"
        />
        <path
          d="M29.0174 19.2627C30.2254 19.954 30.2254 21.6961 29.0174 22.3873L18.3206 28.5085C17.1206 29.1951 15.6266 28.3287 15.6266 26.9462L15.6266 14.7039C15.6266 13.3213 17.1206 12.4549 18.3206 13.1416L29.0174 19.2627Z"
          fill="white"
        />
      </svg>
    ),
    DriverLicenseUploadIcon: (
      <svg {...reset} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M62.625 61.0303H1.375C0.615625 61.0303 0 60.4147 0 59.6553V16.577C0 15.8176 0.615625 15.202 1.375 15.202H14.5793V17.952H2.75V58.2803H61.25V17.952H49.4087V15.202H62.625C63.3844 15.202 64 15.8176 64 16.577V59.6553C64 60.4147 63.3844 61.0303 62.625 61.0303Z"
          fill="#CCCCCC"
        />
        <path
          d="M49.4093 23.162H14.5908C13.8314 23.162 13.2158 22.5464 13.2158 21.787V9.46085C13.2158 8.70148 13.8314 8.08585 14.5908 8.08585H23.1277V2.3446C23.1277 1.58523 23.7433 0.969604 24.5027 0.969604H39.4976C40.2569 0.969604 40.8726 1.58523 40.8726 2.3446V8.08585H49.4094C50.1688 8.08585 50.7844 8.70148 50.7844 9.46085V21.787C50.7843 22.5465 50.1688 23.162 49.4093 23.162ZM15.9658 20.412H48.0344V10.8359H39.4976C38.7382 10.8359 38.1226 10.2202 38.1226 9.46085V3.7196H25.8776V9.46085C25.8776 10.2202 25.2619 10.8359 24.5026 10.8359H15.9657L15.9658 20.412Z"
          fill="#9C94FF"
        />
        <path
          d="M31.2837 51.7606C30.0207 47.3441 25.8951 44.1377 20.9757 43.5858C24.2091 42.8883 26.6399 40.0078 26.6399 36.5688C26.6399 32.6102 23.4193 29.3896 19.4607 29.3896C15.5021 29.3896 12.2814 32.6102 12.2814 36.5688C12.2814 40.0078 14.7124 42.8883 17.9458 43.5858C13.0317 44.1375 8.90744 47.3395 7.64094 51.7498C7.43131 52.4797 7.85306 53.2413 8.58294 53.451C9.31344 53.661 10.0746 53.2387 10.2839 52.5088C11.3422 48.8242 15.1157 46.2508 19.4606 46.2508C23.8099 46.2508 27.5844 48.8275 28.6394 52.5167C28.8122 53.1206 29.3624 53.5141 29.9607 53.5141C30.0858 53.5141 30.2132 53.4968 30.3394 53.4607C31.0698 53.2518 31.4923 52.4907 31.2837 51.7606ZM15.0316 36.5688C15.0316 34.1266 17.0186 32.1396 19.4608 32.1396C21.9031 32.1396 23.8901 34.1266 23.8901 36.5688C23.8901 39.0112 21.9031 40.9981 19.4608 40.9981C17.0186 40.9981 15.0316 39.0112 15.0316 36.5688Z"
          fill="#CCCCCC"
        />
        <path
          d="M55.0006 34.4717H37.5913C36.8319 34.4717 36.2163 33.8561 36.2163 33.0967C36.2163 32.3374 36.8319 31.7217 37.5913 31.7217H55.0004C55.7598 31.7217 56.3754 32.3374 56.3754 33.0967C56.3754 33.8561 55.7599 34.4717 55.0006 34.4717Z"
          fill="#9C94FF"
        />
        <path
          d="M55.0006 42.0963H37.5913C36.8319 42.0963 36.2163 41.4806 36.2163 40.7213C36.2163 39.9619 36.8319 39.3463 37.5913 39.3463H55.0004C55.7598 39.3463 56.3754 39.9619 56.3754 40.7213C56.3754 41.4806 55.7599 42.0963 55.0006 42.0963Z"
          fill="#CCCCCC"
        />
        <path
          d="M55.0006 49.7208H37.5913C36.8319 49.7208 36.2163 49.1051 36.2163 48.3458C36.2163 47.5864 36.8319 46.9708 37.5913 46.9708H55.0004C55.7598 46.9708 56.3754 47.5864 56.3754 48.3458C56.3754 49.1051 55.7599 49.7208 55.0006 49.7208Z"
          fill="#9C94FF"
        />
      </svg>
    ),
  };
  const selectedSVG = name ? svgMap[name] : "";

  if (!selectedSVG) return null;

  return selectedSVG;
};

export default SVGIcon;
